import React, { useState, useEffect } from 'react';
import Constants from 'components/show_drawing/Constants.jsx';

const ShowHideChildOptions = ({ item, option }) => {
  const [visible, setVisible] = useState(false);

  const handleToggle = (e) => {
    e.preventDefault();
    setVisible((prev) => !prev);
  };

  const onVisibleChange = () => {
    const event = new CustomEvent(Constants.child_options_visible_change, {
      detail: {
        item_uuid: item.uuid,
        name: option.name,
        visible: visible
      }
    });
    document.dispatchEvent(event);
  };

  useEffect(() => {
    onVisibleChange();
  }, [visible]);

  // Don't render if no visible children
  if (!option.children || !option.children.some(child => child.visible !== false)) {
    return null;
  }

  return (
    <div style={{ marginTop: '-10px' }}>
      <span className="float-right">
        <a href="#" onClick={handleToggle} style={{ fontSize: '12px', marginLeft: '10px' }}>
          {!visible && (
            <>
              {t('drawing.show_child_options_cta')} <i className="fa fa-caret-down" aria-hidden="true"></i>
            </>
          )}
          {visible && (
            <>
              {t('drawing.hide_child_options_cta')} <i className="fa fa-caret-up" aria-hidden="true"></i>
            </>
          )}
        </a>
      </span>
      <div style={{ clear: 'both' }}></div>
    </div>
  );
};

export default ShowHideChildOptions;
